// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-bar[data-v-ce68b56c] {\n  margin-bottom: 0 !important;\n  margin-top: 0;\n}\n.table-loading[data-v-ce68b56c] {\n  min-height: 200px;\n}", ""]);
// Exports
module.exports = exports;
